module.exports = __webpack_public_path__ + "img/podcast.ea8d4620.svg";